import React from "react";
import * as S from "./Response.style";
import Button from "../Button";
import { ReactComponent as IconPhone } from "../../../../assets/images/habitacional/phone-icon-blue.svg";
import { ReactComponent as IconZapZap } from "../../../../assets/images/habitacional/whatsapp-icon-blue.svg";
import { ReactComponent as Illustration } from "../../../../assets/images/habitacional/response-illustration.svg";
import { ReactComponent as IllustrationDesk } from "../../../../assets/images/habitacional/response-illustration-desk.svg";
import ContentSection from "../../ContentSection";
import BackNavigationButton from "../BackNavigationButton/BackNavigationButton";

const Response = () => {
  const handleClickToUrl = (url) => {
    if (!url) {
      return;
    }

    window.open(url);
  };

  return (
    <ContentSection>
      <S.Container>
        <S.FirstColumn>
          <S.SectionTitle>Ops, algo deu errado :(</S.SectionTitle>
          <BackNavigationButton href="/paravoce/habitacional" />
        </S.FirstColumn>
        <S.SecondColumn>
          <S.CoverMobile>
            <Illustration />
          </S.CoverMobile>
          <S.CoverDesk>
            <IllustrationDesk />
          </S.CoverDesk>
          <S.SectionSubTitle>
            Nosso sistema está indisponível no momento.
          </S.SectionSubTitle>
          <S.SectionParagraph>
            Você pode tentar novamente mais tarde ou, se preferir, acione o
            seguro pelo nosso WhatsApp ou pelo telefone.
          </S.SectionParagraph>
          <S.ContactContainer>
            <S.ContactCard>
              <S.ContactContent>
                <div>
                  <IconZapZap />
                </div>
                <S.ContactParagraph>
                  Fale com a gente no WhatsApp pelo número 0800 274 1000. De
                  segunda a sexta, das 8h às 18h, exceto feriados.
                </S.ContactParagraph>
              </S.ContactContent>
              <Button
                variant="muted-primary"
                onClick={() => handleClickToUrl("https://wa.me/+5508007492020")}
              >
                Abrir WhatsApp
              </Button>
            </S.ContactCard>
            <S.ContactCard>
              <S.ContactContent>
                <div>
                  <IconPhone />
                </div>
                <S.ContactParagraph>
                  Fale com a gente no telefone, pelo número 0800 749 2020. 24h,
                  todos os dias da semana.
                </S.ContactParagraph>
              </S.ContactContent>
              <Button
                variant="muted-primary"
                onClick={() => handleClickToUrl("tel:0800 749 2020")}
              >
                Ligar agora
              </Button>
            </S.ContactCard>
          </S.ContactContainer>
        </S.SecondColumn>
      </S.Container>
    </ContentSection>
  );
};

export default Response;
